import { ApiError } from "@lumora/bridge";
import { PublicOrderTicket } from "../models/PublicOrderTicket.js";
import { ViewModel } from "../mvvm/ViewModel.js";
const LOAD_ERROR = "We could not load this order right now. Please try again.";
/**
 * PublicOrderStatusViewModel loads the kitchen-ticket QR lookup (no auth, no PII).
 */
export class PublicOrderStatusViewModel extends ViewModel {
    client;
    slug;
    token = "";
    constructor(client, slug) {
        super({ phase: "idle", loading: false, error: null, ticket: null, tracking: null });
        this.client = client;
        this.slug = slug;
    }
    async load(token) {
        this.token = token;
        const t = token.trim();
        if (!t) {
            this.setState({ phase: "empty", loading: false, error: null, ticket: null, tracking: null });
            return;
        }
        this.setState({ phase: "loading", loading: true, error: null });
        try {
            const dto = await this.client.getPublicOrderStatus(this.slug, t);
            this.setState({
                phase: "ready",
                loading: false,
                error: null,
                ticket: new PublicOrderTicket(dto.number, dto.status),
                tracking: dto.fulfilment
                    ? {
                        fulfilment: dto.fulfilment,
                        carrier: dto.carrier ?? "",
                        trackingNumber: dto.trackingNumber ?? "",
                        trackingUrl: dto.trackingUrl ?? "",
                        events: dto.events ?? [],
                    }
                    : null,
            });
        }
        catch (err) {
            if (err instanceof ApiError && err.status === 404) {
                this.setState({ phase: "empty", loading: false, error: null, ticket: null, tracking: null });
                return;
            }
            this.setState({ phase: "error", loading: false, ticket: null, tracking: null, error: LOAD_ERROR });
        }
    }
    async retry() {
        await this.load(this.token);
    }
}
//# sourceMappingURL=PublicOrderStatusViewModel.js.map